"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const native_1 = require("@react-navigation/native");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const styles_1 = __importDefault(require("../../styles/styles"));
const eventConstants_1 = require("../../constants/eventConstants");
const navBar_1 = __importDefault(require("../../components/navBar/navBar"));
const boxTitle_1 = __importDefault(require("../../components/boxTitle/boxTitle"));
const notificationsTable_1 = __importDefault(require("../../components/notifications/notificationsTable"));
const screenConstants_1 = require("../../constants/screenConstants");
const typesConstants_1 = require("../../constants/typesConstants");
const pressable_1 = __importDefault(require("../../components/pressable/pressable"));
const icon_1 = __importDefault(require("../../components/icon/icon"));
const spinner_1 = __importDefault(require("../../components/spinner/spinner"));
const paginatedMessageComponent_1 = __importDefault(require("../../components/messageComponent/paginatedMessageComponent"));
const colors_1 = __importDefault(require("../../styles/colors"));
const filterNotification_1 = __importDefault(require("../../components/notifications/filterNotification"));
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const useAppDispatch_1 = __importDefault(require("../../hooks/useAppDispatch"));
const notificationSlice_1 = require("./notificationSlice");
const Notifications = () => {
    const dispatch = useAppDispatch_1.default();
    const navigator = native_1.useNavigation();
    const { notifications, loadingStatus, currentPage } = useAppSelector_1.default((state) => ({
        notifications: state.notifications.notifications,
        loadingStatus: state.notifications.loadingStatus,
        currentPage: state.notifications.currentPage || 1,
    }));
    const today = new Date().toISOString().split('T')[0];
    const [queryParams, setQueryParams] = react_1.useState({
        send_at: today,
    });
    const onPageChange = (page) => {
        dispatch(notificationSlice_1.resetNotificationState());
        dispatch(notificationSlice_1.getNotifications({ ...queryParams, page }));
    };
    native_1.useFocusEffect(react_1.useCallback(() => {
        // Fetch by default current day's notifications
        dispatch(notificationSlice_1.getNotifications({ ...queryParams, page: currentPage }));
    }, []));
    return (react_1.default.createElement(navBar_1.default, null,
        react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.alignSpaceBetween] },
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.marginTen] },
                react_1.default.createElement(boxTitle_1.default, { title: "Notifications" })),
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterEnd, styles_1.default.flexOne] },
                react_1.default.createElement(react_native_1.View, null,
                    react_1.default.createElement(pressable_1.default, { onPress: () => navigator.navigate(screenConstants_1.DASHBOARD_SCREEN), style: [styles_1.default.flexDirectionRow, styles_1.default.alignCenterCenter], eventName: eventConstants_1.NAVIGATE_HOME_BUTTON },
                        react_1.default.createElement(react_native_1.View, null,
                            react_1.default.createElement(icon_1.default, { icon: free_solid_svg_icons_1.faArrowLeft })),
                        react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginTen },
                            react_1.default.createElement(react_native_paper_1.Title, { style: styles_1.default.textColorBlue }, ` Dashboard `)))))),
        react_1.default.createElement(react_native_1.View, null, loadingStatus === typesConstants_1.PENDING_STATUS ? (react_1.default.createElement(spinner_1.default, null)) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_native_1.View, null,
                react_1.default.createElement(filterNotification_1.default, { queryParams: queryParams, setQueryParams: setQueryParams }),
                loadingStatus === typesConstants_1.SUCCEEDED_STATUS && notifications.length === 0 ? (react_1.default.createElement(paginatedMessageComponent_1.default, { message: "No Notifications Found.", color: colors_1.default.BLUE, icon: free_solid_svg_icons_1.faSadTear })) : (react_1.default.createElement(notificationsTable_1.default, { onPageChange: onPageChange }))))))));
};
exports.default = Notifications;
